import React from 'react';
import styles from './WhoFits.module.css';
import { FaHeart, FaHandHoldingUsd, FaEye, FaStar, FaRocket, FaTimes } from 'react-icons/fa';
import Button from '../button/Button';

const WhoFits = () => {
  // מתאים לך להיכנס לתחום אם את...
  const fitsList = [
    {
      text: "אוהבת יופי, סדר ודיוק",
      icon: <FaHeart className={styles.icon} />
    },
    {
      text: "יש לך ידיים טובות ועין לפרטים",
      icon: <FaEye className={styles.icon} />
    },
    {
      text: "מחפשת מקצוע רווחי שאפשר לצמוח בו מהר",
      icon: <FaHandHoldingUsd className={styles.icon} />
    },
    {
      text: "רוצה עצמאות ולא תלויה באף אחד",
      icon: <FaStar className={styles.icon} />
    },
    {
      text: "יש לך חלום – והיא מוכנה להפוך אותו למציאות",
      icon: <FaRocket className={styles.icon} />
    }
  ];

  // לא מתאים לך להיכנס לתחום אם את...
  const notFitsList = [
    {
      text: "מחפשת \"רק תעודה\" ולא באמת רוצה להתאמץ",
      icon: <FaTimes className={styles.iconNegative} />
    },
    {
      text: "מחפשת קיצור דרך, בלי לתרגל ובלי להשקיע",
      icon: <FaTimes className={styles.iconNegative} />
    },
    {
      text: "לא מוכנה לקבל הערות כדי להשתפר",
      icon: <FaTimes className={styles.iconNegative} />
    },
    {
      text: "לא באה מהלב – כי כאן לומדים באהבה ובאחריות",
      icon: <FaTimes className={styles.iconNegative} />
    },
    {
      text: "חושבת שזה \"עוד קורס\" – ולא התחלה של קריירה",
      icon: <FaTimes className={styles.iconNegative} />
    }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.glowEffect}></div>
      
      <div className={styles.sectionWrapper}>
        <div className={styles.section}>
          <h2 className={styles.title}>למי זה מתאים – להיכנס לתחום הציפורניים?</h2>
          <div className={styles.line}></div>
          
          <ul className={styles.list}>
            {fitsList.map((item, index) => (
              <li key={`fit-${index}`} className={styles.listItem}>
                <div className={styles.iconWrapper}>
                  {item.icon}
                </div>
                <p className={styles.itemText}>{item.text}</p>
              </li>
            ))}
          </ul>

          <div className={styles.bottomText}>
            <p>ולא, את לא חייבת ניסיון קודם.</p>
            <p>ולא, את לא צריכה תקציב ענק כדי להתחיל.</p>
            <p>רק רצון, התמדה – ומישהי שתראה אותך באמת ותקפיץ אותך קדימה.</p>
            <p>וזה בדיוק מה שאני עושה עבור כל אחת מהתלמידות שלי.</p>
            <p><strong>באהבה. במסירות. ועם שיטה מנצחת.</strong></p>
            <p className={styles.highlight}>אם את מרגישה שזה בשבילך – כנראה שזה הזמן שלך.</p>
            <p className={styles.highlight}>תלחצי על הכפתור למטה ותשאירי פרטים לשיחה אישית איתי</p>
          </div>

     
        </div>

        <div className={styles.section}>
          <h2 className={styles.title}>למי הקורס לא מתאים?</h2>
          <div className={styles.lineNegative}></div>
          
          <ul className={styles.list}>
            {notFitsList.map((item, index) => (
              <li key={`notfit-${index}`} className={styles.listItemNegative}>
                <div className={styles.iconWrapperNegative}>
                  {item.icon}
                </div>
                <p className={styles.itemText}>{item.text}</p>
              </li>
            ))}
          </ul>

          <div className={styles.bottomTextNegative}>
            <p><strong>אצלי אין חאפר. אין קיצורי דרך.</strong></p>
            <p>יש דרך אחת – דרך של מקצועיות, תוצאות ואמונה בעצמך.</p>
            <p className={styles.highlight}>אם את מוכנה באמת להשקיע ולקחת את עצמך לשלב הבא – אני איתך יד ביד 💪</p>
            <p className={styles.lowlight}>אבל אם לא – זה פשוט לא המקום הנכון.</p>
            <p className={styles.strong}>כי הקורס שלי מיועד למי שבאה לנצח.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhoFits;